/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_PurchaseInputs */

const en_price_purchase = /** @type {(inputs: Price_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase`)
};

/**
* | output |
* | --- |
* | "Purchase" |
*
* @param {Price_PurchaseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const price_purchase = /** @type {((inputs?: Price_PurchaseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_PurchaseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_price_purchase(inputs)
});